import React from "react";
import styled from "styled-components";
import {BlueButton} from "./ButtonStyles";

const ActWithTeamButton = ({setOpenActWithTeamModal}) => {

    return (
        <Btn onClick={() => setOpenActWithTeamModal(true)}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                enableBackground="new 0 0 24 24"
                height="24px" viewBox="0 0 24 24"
                width="24px" fill="#fafafa"
            >
                <rect fill="none" height="24" width="24"/>
                <g>
                    <path
                        d="M12,12.75c1.63,0,3.07,0.39,4.24,0.9c1.08,0.48,1.76,1.56,1.76,2.73L18,17c0,0.55-0.45,1-1,1H7c-0.55,0-1-0.45-1-1l0-0.61 c0-1.18,0.68-2.26,1.76-2.73C8.93,13.14,10.37,12.75,12,12.75z M4,13c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2s-2,0.9-2,2 C2,12.1,2.9,13,4,13z M5.13,14.1C4.76,14.04,4.39,14,4,14c-0.99,0-1.93,0.21-2.78,0.58C0.48,14.9,0,15.62,0,16.43L0,17 c0,0.55,0.45,1,1,1l3.5,0v-1.61C4.5,15.56,4.73,14.78,5.13,14.1z M20,13c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2s-2,0.9-2,2 C18,12.1,18.9,13,20,13z M24,16.43c0-0.81-0.48-1.53-1.22-1.85C21.93,14.21,20.99,14,20,14c-0.39,0-0.76,0.04-1.13,0.1 c0.4,0.68,0.63,1.46,0.63,2.29V18l3.5,0c0.55,0,1-0.45,1-1L24,16.43z M12,6c1.66,0,3,1.34,3,3c0,1.66-1.34,3-3,3s-3-1.34-3-3 C9,7.34,10.34,6,12,6z"/>
                </g>
            </svg>
            <p> Agir avec mon équipe </p>
        </Btn>
    )
}

const Btn = styled(BlueButton)`
  width: 15rem;
  padding: 0.3rem;
  &:hover {
    justify-content: center;
    svg{
      fill: var(--color-blue);
    }
  }
`

export default ActWithTeamButton;